module.exports = __webpack_public_path__ + "img/700644b.png";